const LineChartSection = (props) => {
  const { title, subtitle, linesArray, width, baseWidth, spacing, lineThickness, data } = props;
  return (
    <>
      {!!title && <h3>{title}</h3>}
      {!!subtitle && <p>{subtitle}</p>}
      <svg width={width} height={linesArray.length * 50 + 50}>
        {linesArray.map((key) => {
          const x1 = width - baseWidth - spacing * key;
          const x2 = width;
          const y = 50 + key * 50; // Espaciado vertical
          const midX = (x1 + x2) / 2; // Posición horizontal del centro de la línea
          return (
            <g key={key}>
              {/* Línea */}
              <line x1={x1} y1={y} x2={x2} y2={y} stroke="#242323" strokeWidth={lineThickness} />
              {/* Texto centrado dentro de la línea */}
              <text
                x={midX}
                y={y + 5}
                fill="white"
                fontSize="14"
                textAnchor="middle"
                dominantBaseline="middle"
              >
                {data[key]?.value}
              </text>
              <text x={x1 - 20} y={y + 5} fill="black" fontSize="14" textAnchor="end">
                {data[key]?.name}
              </text>
            </g>
          );
        })}
      </svg>
    </>
  );
};

export default LineChartSection;
